import React from 'react';
import ReactDOM from 'react-dom/client';
import config from './config/config';
import { Header } from './components/layout/header/header';
import { Menu } from './components/layout/menu/menu';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import Icon from './components/icon/icon';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <div className="flex flex-col min-h-screen bg-[#F8FAFC]">
      <Header />
      <Menu />
      <main className="flex-1">
        <div className="lg:ml-64 min-h-screen">
          <div className="pt-20 pb-12">
            <div className="hidden lg:flex flex-col max-w-7xl mx-auto px-6 lg:px-8 gap-6">
              <Routes>
                {config.routes.map(({ path, element }, index) => (
                  <Route key={index} path={path} element={element} />
                ))}
              </Routes>
            </div>
            <div className="lg:hidden p-8 flex flex-col items-center justify-center min-h-[60vh] text-center">
              <div className="w-16 h-16 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center mb-4 shadow-sm">
                <Icon className="text-3xl">triangle-exclamation</Icon>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-2">Vista de Escritorio Recomendada</h3>
              <p className="text-slate-500 text-sm max-w-md">
                Esta plataforma de telemetría y análisis ambiental está optimizada para pantallas de escritorio.
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  </Router>
);

